import React from "react";
import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";
import { ReactComponent as WhatsappIcon } from "../assets/WhatsApp.svg"; // عدلي المسار حسب مكان ملفك

export default function WhatsAppButton() {
  return (
    <motion.a
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
      href="https://wa.me/966579379779"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 w-16 h-20 z-40 flex items-center justify-center rounded-full  text-white transition-all duration-300"
      aria-label="Chat on WhatsApp"
    >
      <WhatsappIcon className="w-20 h-20" />
    </motion.a>
  );
}
